var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Requested Content'
      }],
      "title": "All Requested Content"
    }
  }), _c('div', {
    staticClass: "bg-white p-4 my-3 rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex justify-between items-center align-middle mb-4"
  }, [_c('div', {
    staticClass: "block relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter,
      expression: "filter"
    }],
    staticClass: "bg-gray-100 rounded-lg py-2 px-4 border w-96",
    attrs: {
      "placeholder": "Search User Email, Content Title, Author"
    },
    domProps: {
      "value": _vm.filter
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value;
      }, _vm.filterRequestContent]
    }
  }), _vm.filter ? _c('button', {
    staticClass: "absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.actionReset
    }
  }, [_vm._v(" ✕ ")]) : _vm._e(), !_vm.filter ? _c('svg', {
    staticClass: "w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 right-3",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "d": "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "button_donwload flex"
  }, [_c('button', {
    staticClass: "bg-white rounded-lg px-4 mr-4 py-2 text-gray-700 border flex justify-between",
    class: {
      'opacity-50 pointer-events-none': _vm.item.length === 0
    },
    on: {
      "click": _vm.btndownloadCSV
    }
  }, [_c('svg', {
    staticClass: "w-5 h-5 mr-2 text-gray-800 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2 2 2 0 0 0 2 2h12a2 2 0 0 0 2-2 2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2V4a2 2 0 0 0-2-2h-7Zm1.018 8.828a2.34 2.34 0 0 0-2.373 2.13v.008a2.32 2.32 0 0 0 2.06 2.497l.535.059a.993.993 0 0 0 .136.006.272.272 0 0 1 .263.367l-.008.02a.377.377 0 0 1-.018.044.49.49 0 0 1-.078.02 1.689 1.689 0 0 1-.297.021h-1.13a1 1 0 1 0 0 2h1.13c.417 0 .892-.05 1.324-.279.47-.248.78-.648.953-1.134a2.272 2.272 0 0 0-2.115-3.06l-.478-.052a.32.32 0 0 1-.285-.341.34.34 0 0 1 .344-.306l.94.02a1 1 0 1 0 .043-2l-.943-.02h-.003Zm7.933 1.482a1 1 0 1 0-1.902-.62l-.57 1.747-.522-1.726a1 1 0 0 0-1.914.578l1.443 4.773a1 1 0 0 0 1.908.021l1.557-4.773Zm-13.762.88a.647.647 0 0 1 .458-.19h1.018a1 1 0 1 0 0-2H6.647A2.647 2.647 0 0 0 4 13.647v1.706A2.647 2.647 0 0 0 6.647 18h1.018a1 1 0 1 0 0-2H6.647A.647.647 0 0 1 6 15.353v-1.706c0-.172.068-.336.19-.457Z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" Export CSV ")]), _c('t-dropdown', {
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function (_ref) {
        var mousedownHandler = _ref.mousedownHandler,
          focusHandler = _ref.focusHandler,
          blurHandler = _ref.blurHandler,
          keydownHandler = _ref.keydownHandler;
        return _c('div', {
          staticClass: "flex"
        }, [_c('button', {
          staticClass: "flex items-center justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg",
          on: {
            "mousedown": mousedownHandler,
            "focus": focusHandler,
            "blur": blurHandler,
            "keydown": keydownHandler
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 mr-1 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
          }
        })]), _vm._v(" Filter "), _c('svg', {
          staticClass: "w-5 h-5 ml-1 text-gray-600 fill-current",
          attrs: {
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('polygon', {
          attrs: {
            "points": "9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
          }
        })])])]);
      }
    }, {
      key: "default",
      fn: function (_ref2) {
        var hide = _ref2.hide,
          blurHandler = _ref2.blurHandler;
        return _c('div', {
          staticClass: "w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
        }, [_c('div', {
          staticClass: "block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100",
          attrs: {
            "role": "menuitem"
          }
        }, [_c('div', {
          staticClass: "flex justify-between mb-0 mt-2"
        }, [_c('div', [_c('div', {
          staticClass: "mb-4"
        }, [_vm._v(" Filter ")]), _c('h4', {
          staticClass: "text-sm text-gray-800"
        }, [_vm._v(" Request Date")])]), _c('div', {
          on: {
            "click": hide
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 text-gray-800 dark:text-white cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M6 18 17.94 6M18 18 6.06 6"
          }
        })])])]), _c('div', {
          staticClass: "grid gap-2 grid-cols-2"
        }, [_c('div', [_c('DatetimeCustom', {
          attrs: {
            "timeDate": false,
            "label": 'Start Date'
          },
          on: {
            "blur": blurHandler
          },
          model: {
            value: _vm.start_date,
            callback: function ($$v) {
              _vm.start_date = $$v;
            },
            expression: "start_date"
          }
        })], 1), _c('div', [_c('DatetimeCustom', {
          attrs: {
            "timeDate": false,
            "label": 'End Date'
          },
          on: {
            "blur": blurHandler
          },
          model: {
            value: _vm.end_date,
            callback: function ($$v) {
              _vm.end_date = $$v;
            },
            expression: "end_date"
          }
        })], 1)]), _c('div', {
          staticClass: "mt-3"
        }, [_c('button', {
          staticClass: "border bg-blue-500 px-4 py-2 text-white rounded-lg",
          on: {
            "click": _vm.filterRequestContent,
            "blur": blurHandler
          }
        }, [_vm._v(" Filter ")]), _c('button', {
          staticClass: "border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2",
          on: {
            "click": function ($event) {
              return _vm.actionReset();
            },
            "blur": blurHandler
          }
        }, [_vm._v("Reset")])])])]);
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "w-full"
  }, [_c('TableRequestContent', {
    attrs: {
      "currentpage": _vm.currentPage,
      "perpage": _vm.perPage,
      "data": _vm.item,
      "isLoading": _vm.isLoading
    }
  })], 1), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 items-center mt-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }